/* global Intl */

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
import IntlPolyfill from 'intl'
import areIntlLocalesSupported from 'intl-locales-supported'

import 'intl/locale-data/jsonp/pt'
import 'intl/locale-data/jsonp/en'
import 'intl/locale-data/jsonp/es'

const localesMyAppSupports = ['pt', 'en', 'es']

if (typeof window !== 'undefined' && !window.Intl) {
  window.Intl = IntlPolyfill
}

export function polyfillBasedOnLocale() {
  if (!areIntlLocalesSupported(localesMyAppSupports)) {
    Intl.NumberFormat = IntlPolyfill.NumberFormat
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat
  }
}
